import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import { useTranslation } from 'react-i18next';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await apiFetch("/api/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      setSent(true);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  if (sent) {
    return (
      <div className="auth-page">
        <button
          className="btn btn-sm btn-secondary mb-2"
          onClick={() => navigate('/login')}
        >
          {t('common.back')}
        </button>
        <img src="/dragon-logo.png" alt="DragonFit" className="auth-logo" />
        <h1 className="auth-title neon-text">DragonFit</h1>
        <p className="auth-subtitle">{t('forgot_password.subtitle')}</p>
        <p style={{ marginTop: 30, textAlign: "center" }}>
          {t('forgot_password.email_sent')}
        </p>
        <Link to="/login">
          <button className="btn btn-primary w-full" style={{ marginTop: 30 }}>
            {t('forgot_password.back_to_login')}
          </button>
        </Link>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <button
        className="btn btn-sm btn-secondary mb-2"
        onClick={() => navigate('/login')}
      >
        {t('common.back')}
      </button>
      <img src="/dragon-logo.png" alt="DragonFit" className="auth-logo" />
      <h1 className="auth-title neon-text">DragonFit</h1>
      <p className="auth-subtitle">{t('forgot_password.subtitle')}</p>

      <h2 style={{ marginTop: 20 }}>{t('forgot_password.title')}</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="tu@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input"
          style={{ marginBottom: 20 }}
        />
        <button className="btn btn-primary w-full" disabled={loading}>
          {loading ? <span className="loading-spinner"></span> : t('forgot_password.send_btn')}
        </button>
      </form>
    </div>
  );
};

export default ForgotPasswordPage;
